import React, { useEffect } from 'react'
import { useLocale } from '../contexts/LocaleContext'
import { APP_STORE_URL, PLAY_STORE_URL } from '../constants/stores'

const DEEP_LINK = 'gymjourney://notifications'

function OpenNotifications() {
  const { t } = useLocale()

  useEffect(() => {
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent || '')
    if (!isMobile) {
      return
    }
    window.location.replace(DEEP_LINK)
  }, [])

  const openApp = () => {
    window.location.href = DEEP_LINK
  }

  return (
    <section className="section coach-invite">
      <div className="container coach-invite-container">
        <div className="coach-invite-card">
          <h1>{t.notificationsOpen.title}</h1>
          <p className="lead">{t.notificationsOpen.description}</p>
          <div className="coach-invite-actions">
            <div className="coach-invite-actions-open">
              <button className="btn primary coach-invite-open-app-btn" type="button" onClick={openApp}>
                <img
                  className="badge coach-invite-open-app-logo"
                  src="/assets/logo_no_bg.svg"
                  alt=""
                  width="36"
                  height="36"
                />
                <span>{t.notificationsOpen.openApp}</span>
              </button>
            </div>
            <div className="coach-invite-actions-stores">
              <a
                className="btn primary coach-invite-store-link"
                href={APP_STORE_URL}
                rel="noopener"
                aria-label={t.notificationsOpen.downloadIos}
              >
                <img
                  className="badge coach-invite-store-badge"
                  src="/assets/app_store_logo.webp"
                  alt={t.notificationsOpen.downloadIos}
                  width="120"
                  height="40"
                />
                <span>App Store</span>
              </a>
              <a
                className="btn primary coach-invite-store-link"
                href={PLAY_STORE_URL}
                rel="noopener"
                aria-label={t.notificationsOpen.downloadAndroid}
              >
                <img
                  className="badge coach-invite-store-badge coach-invite-store-badge--play"
                  src="/assets/google_play_logo.webp"
                  alt={t.notificationsOpen.downloadAndroid}
                  width="140"
                  height="125"
                />
                <span>Google Play</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default OpenNotifications
